let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Vhzbo")).then(() => parcelRequire('b7x2U'));